import {Injectable} from '@angular/core';
import {MbDatatablesTemplate} from "../../components/mb-datatable/mb-datatables-template";
import {FilterService} from "../filterer/filter.service";
import {DataManipulationService} from "./data-manipulation.service";
import {ValidatorService} from "./validator.service";
import {BaseRepository} from "../../repositories/base/base.repository";
import {BaseModel} from "../../models/base.model";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {MbColDefinition, MbColInput} from "../../components/mb-datatable/models/mb-datatable.model";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class BaseService<REPO extends BaseRepository> {
    protected typeName: string = "";
    idCol: MbColDefinition = null;


    constructor(
        public repo: REPO,
        public filterService: FilterService,
        public dataManipulationService: DataManipulationService,
        public validatorService: ValidatorService) {
    }

    /**
     * alapértelmezett filter lekérés deleted false szűréssel
     * @param dto
     */
    public getAll(dto: string) {
        const filter = this.filterService.filter(dto)
            .equal("deleted", false).create();
        return this.repo.getAllByFilter(filter);
    }


    /**
     * id alapján egy elem lekérése
     * @param dto
     */
    public getOneById(dto: string, id: number) {
        const filter = this.filterService.filter(dto)
            .equal("id", id).create();
        return this.repo.getAllByFilter(filter).pipe(
            map((response: any[]) => {
                if (response.length == 0) {
                    throw new Error('error.getOneById.notFound');
                } else if (response.length > 1) {
                    throw new Error('error.getOneById.moreThanOneFound');
                }
                return response[0];
            })
        );
    }

    protected defineModelSpecificColumns(extraInfo?: any): any[] {
        return [];
    }

    public validate(model: any) {
        throw new Error("error.notImplementYet");
    }

    public addExtraDataForOne<T>(model: T): T {
        return model;
    }

    public addExtraDataForAll<T>(models: T[]): T[] {
        models.forEach(model => {
            model = this.addExtraDataForOne<T>(model);
        });
        return models;
    }

    public defineColumns(extraInfo?: any) {
        const cols = this.defineModelSpecificColumns(extraInfo);
        cols.unshift(this.idCol ? this.idCol : MbColDefinition.new('id', 'base.id'));
        cols.push(MbColDefinition.new('createdAt', 'base.createdAt', MbColInput.newDefaultText(), MbDatatablesTemplate.DATETIME_TEMPLATE));
        return cols;
    }

    public deleteById(id): Observable<any> {
        return this.repo.deleteById(id);
    }

    public save<T extends BaseModel>(model: T): Observable<any> {
        const payload = {
            id: null,
            type: this.typeName,
            attribute: model
        };
        return this.repo.save(payload);
    }

    public update<T extends BaseModel>(model: T): Observable<any> {
        const payload = {
            id: model.id,
            type: this.typeName,
            attribute: model
        };
        return this.repo.update(payload);
    }
}
